import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  base: __dirname,
  mode: 'history',
  routes: [
    {
      path: '/',
      component: resolve => require(['../views/applicationForm/orderDetail.vue'], resolve),
      meta: {
        title: 'pageTitle.index'
      }
    },
    // {
    //   path: '',
    //   name: 'login',
    //   component: resolve => require(['../views/login'], resolve),
    //   meta: {
    //     title: 'pageTitle.index'
    //   }
    // },
    // {
    //   path: '/travelAgency',
    //   name: 'travelAgency',
    //   component: resolve => require(['../views/travelAgency'], resolve),
    //   meta: {
    //     title: 'pageTitle.TravelAgencyIdentity',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/invoice',
    //   name: 'invoice',
    //   component: resolve => require(['../views/invoice'], resolve),
    //   meta: {
    //     title: 'pageTitle.applyInvoice',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visaquery',
    //   name: 'visaquery',
    //   component: resolve => require(['../views/visaquery'], resolve),
    //   meta: {
    //     title: 'pageTitle.visaInQuery',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/queryResults',
    //   name: 'queryResults',
    //   component: resolve => require(['../views/queryResults'], resolve),
    //   meta: {
    //     title: 'pageTitle.queryResults',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/account/login',
    //   name: 'login',
    //   component: resolve => require(['../views/account/login'], resolve),
    //   meta: {
    //     title: 'pageTitle.login',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/account/register',
    //   name: 'register',
    //   component: resolve => require(['../views/account/register'], resolve),
    //   meta: {
    //     title: 'pageTitle.register',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/account/retrieve',
    //   name: 'retrieve',
    //   component: resolve => require(['../views/account/retrieve'], resolve),
    //   meta: {
    //     title: 'pageTitle.retrieve',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/choiceVisaType',
    //   name: 'choiceVisaType',
    //   component: resolve => require(['../views/visa/choiceVisaType'], resolve),
    //   meta: {
    //     title: 'pageTitle.choiceVisaType',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/form/saveBasicInfo',
    //   name: 'saveBasicInfo',
    //   component: resolve => require(['../views/visa/form/saveBasicInfo'], resolve),
    //   meta: {
    //     title: 'pageTitle.saveBasicInfo',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/form/confirmApply',
    //   name: 'confirmApply',
    //   component: resolve => require(['../views/visa/form/confirmApply'], resolve),
    //   meta: {
    //     title: 'pageTitle.confirmApply',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/form/saveApplyInfo',
    //   name: 'saveApplyInfo',
    //   component: resolve => require(['../views/visa/form/saveApplyInfo'], resolve),
    //   meta: {
    //     title: 'pageTitle.saveApplyInfo',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/applyTodoList',
    //   name: 'applyTodoList',
    //   component: resolve => require(['../views/visa/applyTodoList'], resolve),
    //   meta: {
    //     title: 'pageTitle.applyTodoList',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/form/saveSendInfo',
    //   name: 'saveSendInfo',
    //   component: resolve => require(['../views/visa/form/saveSendInfo'], resolve),
    //   meta: {
    //     title: 'pageTitle.saveSendInfo',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/news',
    //   name: 'news',
    //   component: resolve => require(['../views/article/news'], resolve),
    //   meta: {
    //     title: 'pageTitle.news',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/law',
    //   name: 'law',
    //   component: resolve => require(['../views/article/law'], resolve),
    //   meta: {
    //     title: 'pageTitle.law',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/serviceCenter/serviceCenter',
    //   name: 'serviceCenter',
    //   component: resolve => require(['../views/serviceCenter/serviceCenter'], resolve),
    //   meta: {
    //     title: 'pageTitle.serviceCenter',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/tour',
    //   name: 'tour',
    //   component: resolve => require(['../views/article/tour'], resolve),
    //   meta: {
    //     title: 'pageTitle.tour',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/aboutUs/aboutUs',
    //   name: 'aboutUs',
    //   component: resolve => require(['../views/aboutUs/aboutUs'], resolve),
    //   meta: {
    //     title: 'pageTitle.aboutUs',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/aboutUs/contactUs',
    //   name: 'contactUs',
    //   component: resolve => require(['../views/aboutUs/contactUs'], resolve),
    //   meta: {
    //     title: 'pageTitle.contactUs',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/aboutUs/businessCooperation',
    //   name: 'businessCooperation',
    //   component: resolve => require(['../views/aboutUs/businessCooperation'], resolve),
    //   meta: {
    //     title: 'pageTitle.businessCooperation',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/orderList',
    //   name: 'orderList',
    //   component: resolve => require(['../views/order/orderList'], resolve),
    //   meta: {
    //     title: 'pageTitle.orderList',
    //     role: true
    //   }
    // },
    // {
    //   path: '/user/address',
    //   name: 'address',
    //   component: resolve => require(['../views/user/address'], resolve),
    //   meta: {
    //     title: 'pageTitle.address',
    //     role: true,
    //   }
    // },
    // {
    //   path: '/user/addressDetail',
    //   name: 'addressDetail',
    //   component: resolve => require(['../views/user/addressDetail'], resolve),
    //   meta: {
    //     title: 'pageTitle.addressDetail',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/sendDataInfo',
    //   name: 'sendDataInfo',
    //   component: resolve => require(['../views/visa/sendDataInfo'], resolve),
    //   meta: {
    //     title: 'pageTitle.sendDataInfo',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/receiveDataInfo',
    //   name: 'receiveDataInfo',
    //   component: resolve => require(['../views/visa/receiveDataInfo'], resolve),
    //   meta: {
    //     title: 'pageTitle.receiveDataInfo',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/visaData',
    //   name: 'visaData',
    //   component: resolve => require(['../views/article/visaData'], resolve),
    //   meta: {
    //     title: 'pageTitle.visaData',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/confirmPay',
    //   name: 'confirmPay',
    //   component: resolve => require(['../views/order/confirmPay'], resolve),
    //   meta: {
    //     title: 'pageTitle.confirmPay',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/orderDetail',
    //   name: 'orderDetail',
    //   component: resolve => require(['../views/order/orderDetail'], resolve),
    //   meta: {
    //     title: 'pageTitle.orderDetail',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/generateForm',
    //   name: 'generateForm',
    //   component: resolve => require(['../views/order/generateForm'], resolve),
    //   meta: {
    //     title: '申请表-填写',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/generateFormConfirm',
    //   name: 'generateFormConfirm',
    //   component: resolve => require(['../views/order/generateFormConfirm'], resolve),
    //   meta: {
    //     title: '申请表审核资料',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/generateFormSuccess',
    //   name: 'generateFormSuccess',
    //   component: resolve => require(['../views/order/generateFormSuccess'], resolve),
    //   meta: {
    //     title: '生成申请表',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/confirmApplicant',
    //   name: 'confirmApplicant',
    //   component: resolve => require(['../views/order/confirmApplicant'], resolve),
    //   meta: {
    //     title: 'pageTitle.confirmApplicant',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/user/msgList',
    //   name: 'msgList',
    //   component: resolve => require(['../views/user/msgList'], resolve),
    //   meta: {
    //     title: 'pageTitle.msgList'
    //   }
    // },
    // {
    //   path: '/user/feedback',
    //   name: 'feedback',
    //   component: resolve => require(['../views/user/feedback'], resolve),
    //   meta: {
    //     title: 'pageTitle.feedback',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/articleDetail',
    //   name: 'articleDetail',
    //   component: resolve => require(['../views/article/articleDetail'], resolve),
    //   meta: {
    //     title: '',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/visaCenter',
    //   name: 'visaCenter',
    //   component: resolve => require(['../views/visa/visaCenter'], resolve),
    //   meta: {
    //     title: 'pageTitle.visaCenter',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/account/changePsd',
    //   name: 'changePsd',
    //   component: resolve => require(['../views/account/changePsd'], resolve),
    //   meta: {
    //     title: 'pageTitle.changePsd',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/user/changePhone',
    //   name: 'changePhone',
    //   component: resolve => require(['../views/user/changePhone'], resolve),
    //   meta: {
    //     title: 'pageTitle.changePhone',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/aboutUs/siteMap',
    //   name: 'siteMap',
    //   component: resolve => require(['../views/aboutUs/siteMap'], resolve),
    //   meta: {
    //     title: 'pageTitle.siteMap',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/agreement',
    //   name: 'agreement',
    //   component: resolve => require(['../views/article/agreement'], resolve),
    //   meta: {
    //     title: 'pageTitle.agreement'
    //   }
    // },
    // {
    //   path: '/order/paySuccess',
    //   name: 'paySuccess',
    //   component: resolve => require(['../views/order/paySuccess'], resolve),
    //   meta: {
    //     title: 'pageTitle.paySuccess',
    //     role: true,
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/article/tourList',
    //   name: 'tourList',
    //   component: resolve => require(['../views/article/tourList'], resolve),
    //   meta: {
    //     title: 'pageTitle.tourList',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/user/invoiceList',
    //   name: 'invoiceList',
    //   component: resolve => require(['../views/user/invoiceList'], resolve),
    //   meta: {
    //     title: 'pageTitle.invoiceList',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/user/invoiceDetail',
    //   name: 'invoiceDetail',
    //   component: resolve => require(['../views/user/invoiceDetail'], resolve),
    //   meta: {
    //     title: 'pageTitle.invoiceDetail',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/user/changeEmail',
    //   name: 'changeEmail',
    //   component: resolve => require(['../views/user/changeEmail'], resolve),
    //   meta: {
    //     title: 'pageTitle.changeEmail',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/applyInvoice',
    //   name: 'applyInvoice',
    //   component: resolve => require(['../views/order/applyInvoice'], resolve),
    //   meta: {
    //     title: 'pageTitle.applyInvoice',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/order/expressInfo',
    //   name: 'expressInfo',
    //   component: resolve => require(['../views/order/expressInfo'], resolve),
    //   meta: {
    //     title: 'pageTitle.expressInfo',
    //     scrollTop: true
    //   }
    // },
    // {
    //   path: '/visa/reserve',
    //   name: 'reserve',
    //   component: resolve => require(['../views/visa/reserve'], resolve),
    //   meta: {
    //     title: 'pageTitle.reserve',
    //     scrollTop: true
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js